import { render, staticRenderFns } from "./NavigatorBar.vue?vue&type=template&id=c49405c0&scoped=true"
import script from "./NavigatorBar.vue?vue&type=script&lang=js"
export * from "./NavigatorBar.vue?vue&type=script&lang=js"
import style0 from "./NavigatorBar.vue?vue&type=style&index=0&id=c49405c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49405c0",
  null
  
)

export default component.exports